import React, { useContext } from "react";
import { Grid, Box, Button } from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";

import styles from "../insights.module.css"
import ActionMenu from "./AddEscalation/AddEscalationOptions";
import { useInsights } from "../../../Context/insightContext";
import { DashboardInfoContext, DashboardInfoPayload } from "../../../Context/dashboardContext";
import getOptionTextColor from "../../../utils/getOptionsColor";
import { useInsightsUtils } from "../../../hooks/useInsightsUtils";

interface ActionSectionProps {
    currentTab: number;
    flagAutomatedNotesPresent: boolean;
    onRefresh: (isEscalation?: boolean) => void;
    onCancel: () => void;
    onSave: () => void;
    oppId: string;
    tenantTitle: string;
    onLaunchApplication: () => void;
    piiRemoved: boolean;
}


const ActionSection: React.FC<ActionSectionProps> = (props) => {
    const {
        currentTab,
        flagAutomatedNotesPresent,
        onRefresh,
        onCancel,
        onSave,
        oppId,
        tenantTitle,
        onLaunchApplication,
        piiRemoved,
    } = props;

    const {
        applicationListRows
    } = useContext(DashboardInfoContext) as DashboardInfoPayload;

    const { escalationInfo, associatedEscalation } = useInsights();
    const { HandleAddEscalation } = useInsightsUtils();

    const availableOptions = escalationInfo
        .filter((option)=>(!associatedEscalation.includes(option.escalationUid)))
        .map((item)=>({
            label: item.escalationName,
            value: item.escalationUid,
        }));

    const flagRaiseEscalation = async (id: string, name: string )=>{
        if(oppId == "" || id == ""){
            // No data found
            return;
        }

        await HandleAddEscalation({
            oppId: oppId,
            escalationId: id,
            escalationName: name,
            agencyName: tenantTitle,
        })

    }

    if(currentTab === 0) {
        return (
            <Grid item className={styles.actionClassCtn}>
                {piiRemoved && (
                    <p className={styles.piiRemovedText}>
                        PII Removed
                    </p>
                )}
                <Button
                    sx={{ textTransform: "unset" }}
                    className={styles.launchButtonStyle}
                    onClick={onLaunchApplication}
                >
                    Launch Application
                </Button>
            </Grid>
        );
    }


    if (currentTab === 1) {
        return (
            <Grid item className={styles.actionClassCtn}>
                <Box onClick={() => onRefresh(false)} className={styles.refreshCtn}>
                    <RefreshIcon className={styles.iconStyles} />
                </Box>
                <Button
                    sx={{ textTransform: "unset" }}
                    className={styles.cancelButtonStyle}
                    onClick={onCancel}
                >
                    Cancel
                </Button>
                <Button
                    sx={{ textTransform: "unset" }}
                    className={styles.saveChangesButtonStyle}
                    onClick={onSave}
                >
                    Save & Update
                </Button>
            </Grid>
        );
    }

    if (currentTab === 2) {
        return (
            <Grid item className={`${styles.actionClassCtn} ${styles.addEscalationCustomStyles}`}>
                <ActionMenu
                    onRefresh={onRefresh}
                    onAction={flagRaiseEscalation}
                    options={availableOptions}
                    buttonLabel={"Raise Escalation"}
                    flagCustomColor={true}
                />
            </Grid>
        );
    }

    return null;
};

export default ActionSection;
